import { DOCS_PREFIX_PATH } from 'constants/route.constant'
import {
    NAV_ITEM_TYPE_TITLE,
    NAV_ITEM_TYPE_ITEM,
} from 'constants/navigation.constant'
import { ADMIN, SUPPORT } from 'constants/roles.constant'

const docNavigationConfig = [
    {
        key: 'guide',
        path: '',
        title: 'Guide',
        translateKey: 'nav.docs.guide',
        icon: 'guide',
        type: NAV_ITEM_TYPE_TITLE,
        authority: [ADMIN, SUPPORT],
        subMenu: [
            {
                key: 'docs.documentation',
                path: `${DOCS_PREFIX_PATH}/documentation/introduction`,
                title: 'Documentation',
                translateKey: 'nav.docs.documentation',
                icon: 'documentation',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [ADMIN, SUPPORT],
                subMenu: [],
            },
            {
                key: 'docs.sharedComponentDoc',
                path: `${DOCS_PREFIX_PATH}/shared-component-doc/action-link`,
                title: 'Shared Component',
                translateKey: 'nav.docs.sharedComponentDoc',
                icon: 'sharedComponentDoc',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [ADMIN, SUPPORT],
                subMenu: [],
            },
            {
                key: 'docs.utilsDoc',
                path: `${DOCS_PREFIX_PATH}/utils-doc/use-auth`,
                title: 'Utilities',
                translateKey: 'nav.docs.utilsDoc',
                icon: 'utilsDoc',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [ADMIN, SUPPORT],
                subMenu: [],
            },
            {
                key: 'docs.changeLog',
                path: `${DOCS_PREFIX_PATH}/changelog`,
                title: 'Changelog',
                translateKey: 'nav.docs.changeLog',
                icon: 'changeLog',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [ADMIN, SUPPORT],
                subMenu: [],
            },
        ],
    },
]

export default docNavigationConfig
